// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	AuthButton: 'auth-button',
	ContactLink: 'contact-link',
	LegalLink: 'legal-link',
	ConnectToGoogleButton: 'connect-to-google-button',
} as const;
